import { useContext } from 'react';
import { Grid, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography } from '@material-ui/core';
import Moment from 'react-moment';
import { DeleteIconButton } from 'components';
import { resolutionsContext } from '../ResolutionsContext';
import ResolutionEditor from './ResolutionEditor';
import { ReferenceData } from 'helpers/enums';
import { applicationContext } from 'helpers/services';


interface IProps {
    isReadOnly: boolean
}

let ManualResolutions = (props: IProps) => {
    let service = useContext(resolutionsContext);
    let { referenceData } = useContext(applicationContext)

    return (
        <Grid item xs={12}>
            <Grid container>
                <Grid item xs style={{ backgroundColor: '#efefef' }}>
                    <Typography variant="h5">Manual Resolutions</Typography>
                </Grid>
            </Grid>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Internal Actions</TableCell>
                        <TableCell>Action To Customer</TableCell>
                        <TableCell>Defect</TableCell>
                        <TableCell>Created By</TableCell>
                        <TableCell>Created On</TableCell>
                        {props.isReadOnly === false &&
                            <TableCell align="right">
                                {service.resolutions.length < 1 && <ResolutionEditor />}
                            </TableCell>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.resolutions.map(res =>
                        <TableRow key={res.id}>
                            <TableCell>{referenceData.getByKey(ReferenceData.InternalAction)?.values.getValueByKey(res.internalActions)}</TableCell>
                            <TableCell>{referenceData.getByKey(ReferenceData.ActionToCustomer)?.values.getValueByKey(res.actionToCustomer)}</TableCell>
                            <TableCell>
                                {referenceData.getByKey(ReferenceData.Defect)?.values.getValueByKey(res.defect)}<br />
                                {res.subDefect && res.subDefect !== '' &&
                                    `Sub-defect: ${referenceData.getByKey(ReferenceData.SubDefect)?.values.getValueByKey(res.subDefect)}`
                                }
                            </TableCell>
                            <TableCell>{res.createdBy}</TableCell>
                            <TableCell>
                                <Moment date={res.createdOn} format="ll" />
                            </TableCell>
                            {props.isReadOnly === false &&
                                <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                    <ResolutionEditor resolution={res} />
                                    <DeleteIconButton
                                        onClick={async () => {
                                            await service.deleteTicketResolution(res.id);
                                        }}
                                    />
                                </TableCell>
                            }
                        </TableRow>
                    )}
                </TableBody>
                {service.resolutions.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={props.isReadOnly === false ? 6 : 5}><i>No manual resolutions found</i></TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </Grid>
    )
}

export default ManualResolutions;